module.exports = __webpack_public_path__ + "img/bank-transfer.8f87a8d8.svg";